(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-video-slider"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const carousel = document.querySelector(".custom-video-carousel");
  if (!carousel) return;

  const track = carousel.querySelector(".custom-video-track");
  const slides = Array.from(track.children);
  const prevBtn = document.querySelector(".custom-carousel-prev");
  const nextBtn = document.querySelector(".custom-carousel-next");
  const bulletsContainer = carousel.querySelector(".custom-carousel-bullets");

  const showArrows = carousel.dataset.arrows === "true";
  const showBullets = carousel.dataset.bullets === "true";
  const speed = parseInt(carousel.dataset.speed) || 4000;

  // Detect slides per group (2 on desktop, 1 on mobile)
  let slidesPerGroup = window.innerWidth <= 768 ? 1 : 2;
  let totalGroups = Math.ceil(slides.length / slidesPerGroup);

  let index = 0;
  let interval;

  if (showArrows) {
    prevBtn.style.display = "block";
    nextBtn.style.display = "block";
  }

  if (showBullets) {
    for (let i = 0; i < totalGroups; i++) {
      const btn = document.createElement("button");
      if (i === 0) btn.classList.add("active");
      btn.addEventListener("click", () => goToSlide(i));
      bulletsContainer.appendChild(btn);
    }
    bulletsContainer.style.display = "block";
  }

  function updateCarousel() {
    const offset = index * (100 / slidesPerGroup);
    track.style.transform = `translateX(-${offset}%)`;

    if (showBullets) {
      const bullets = bulletsContainer.querySelectorAll("button");
      bullets.forEach(b => b.classList.remove("active"));
      bullets[index].classList.add("active");
    }
  }

  function goToSlide(i) {
    index = i;
    updateCarousel();
  }

  function nextSlide() {
    index = (index + 1) % totalGroups;
    updateCarousel();
  }

  function prevSlideFn() {
    index = (index - 1 + totalGroups) % totalGroups;
    updateCarousel();
  }

  nextBtn.addEventListener("click", nextSlide);
  prevBtn.addEventListener("click", prevSlideFn);

  if (speed > 0) {
    interval = setInterval(nextSlide, speed);
    carousel.addEventListener("mouseenter", () => clearInterval(interval));
    carousel.addEventListener("mouseleave", () => interval = setInterval(nextSlide, speed));
  }

  // ✅ Recalculate slides per group on resize
  window.addEventListener("resize", () => {
    slidesPerGroup = window.innerWidth <= 768 ? 1 : 2;
    totalGroups = Math.ceil(slides.length / slidesPerGroup);
    index = 0;
    bulletsContainer.innerHTML = "";
    if (showBullets) {
      for (let i = 0; i < totalGroups; i++) {
        const btn = document.createElement("button");
        if (i === 0) btn.classList.add("active");
        btn.addEventListener("click", () => goToSlide(i));
        bulletsContainer.appendChild(btn);
      }
      bulletsContainer.style.display = "block";
    }
    updateCarousel();
  });
});

  } catch(e) { console.error(e); }
})();
})();
